import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomProductHome } from '@atlaskit/atlassian-navigation';

import { Theme, ThemeContext } from '@/controllers';

import * as styles from './styles';

const LOGO_ALT_TEXT = 'Tome';
const LOGO_URL = '/static/logo.svg';
const LOGO_DARK_URL = '/static/logo-dark.svg';

const NavLogo: React.FC = () => {
  const navigate = useNavigate();
  const [theme] = useContext(ThemeContext);
  const logoUrl = theme === Theme.Dark ? LOGO_DARK_URL : LOGO_URL;
  return (
    <CustomProductHome
      onClick={e => {
        e.preventDefault();
        navigate('/');
      }}
      href="/"
      iconAlt={LOGO_ALT_TEXT}
      iconUrl={logoUrl}
      logoAlt={LOGO_ALT_TEXT}
      logoUrl={logoUrl}
      css={[styles.logoWidth]}
    />
  );
};

export default NavLogo;
